module.exports = __webpack_public_path__ + "zip/showtime30x30.zip";